












































































































































































































import { Component, Emit, Ref, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  defaultSystemCode,
  defaultSystemCodeArea,
  SystemCode,
  SystemCodeArea
} from '@/api'
import {
  dataStore,
  systemCodeStore,
  systemParameterStore
} from '@/utils/store-accessor'
import { AtomTextField } from '@/components/atoms'
import { MaskPattern } from '@/types'
import { InputUserId } from '@/components/molecules/InputUserId'

export interface UserSearchConditionsItem {
  name: {
    input: string
    errorMessage: string
  }
  id: {
    input: string
    errorMessage: string
  }
  birthday: {
    input: string
    errorMessage: string
  }
  phoneNumber: {
    input: string
    errorMessage: string
  }
  address: {
    input: string
    errorMessage: string
  }
  mailAddress: {
    input: string
    errorMessage: string
  }
  gender: {
    input: SystemCode
    errorMessage: string
  }
  userType: {
    input: SystemCode
    errorMessage: string
  }
  status: {
    input: SystemCode
    errorMessage: string
  }
  areaCode: {
    input: SystemCodeArea
    errorMessage: string
  }
  workType: {
    input: SystemCode
    errorMessage: string
  }
  studentGrade: {
    input: SystemCode
    errorMessage: string
  }
  studentClass: {
    input: SystemCode
    errorMessage: string
  }
  studentNumber: {
    input: string
    errorMessage: string
  }
}

export const defaultUserSearchConditionsItem = (): UserSearchConditionsItem => ({
  name: {
    input: '',
    errorMessage: ''
  },
  id: {
    input: '',
    errorMessage: ''
  },
  birthday: {
    input: '',
    errorMessage: ''
  },
  phoneNumber: {
    input: '',
    errorMessage: ''
  },
  address: {
    input: '',
    errorMessage: ''
  },
  mailAddress: {
    input: '',
    errorMessage: ''
  },
  gender: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  userType: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  status: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  areaCode: {
    input: defaultSystemCodeArea(),
    errorMessage: ''
  },
  workType: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  studentGrade: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  studentClass: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  studentNumber: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: { InputUserId }
})
export default class UserSearchConditions extends ComponentVue {
  @Ref()
  nameTextField!: AtomTextField

  @Ref()
  inputUserId!: InputUserId

  @PropSync('item', {
    type: Object,
    required: true
  })
  inputItem!: UserSearchConditionsItem

  focus(): void {
    if (systemParameterStore.isFocusNameUserSearchPage) {
      this.nameTextField.atomTextField.focus()
    } else {
      this.inputUserId.focus()
    }
  }

  get displayAdditionalSearch(): boolean {
    return dataStore.displayAdditionalSearch
  }

  get enabledSchool(): boolean {
    return dataStore.enabledSchool
  }

  get halfWidthOnlyMask(): string {
    return MaskPattern.HalfWidthOnly
  }

  get halfWidthWithKanaOnlyMask(): string {
    return MaskPattern.HalfWidthWithKanaOnly
  }

  get systemCodesOfGender(): SystemCode[] {
    return systemCodeStore.getGender
  }

  get systemCodesOfUserType(): SystemCode[] {
    return systemCodeStore.getUserType
  }

  get systemCodesOfWorkType(): SystemCode[] {
    return systemCodeStore.getWorkType
  }

  get systemCodesOfUserStatus(): SystemCode[] {
    return systemCodeStore.getUserStatus
  }

  get systemCodeOfSchoolGradeCode(): SystemCode[] {
    return systemCodeStore.getSchoolGradeCode
  }

  get systemCodeOfSchoolClassCode(): SystemCode[] {
    return systemCodeStore.getSchoolClassCode
  }

  get displayPhone(): boolean {
    return dataStore.displayUserSearchPagePhone
  }

  get displayAddress(): boolean {
    return dataStore.displayUserSearchPageAddress
  }

  get displayMailAddress(): boolean {
    return dataStore.displayUserSearchPageMailAddress
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  @Emit('keydown:enter')
  onKeydownEnter() {}
}
